"use client";

import React from "react";
import { Skeleton } from "@/components/ui/adapters";

/** Skeleton matching not-found page: same wrappers, SectionWrapper, Footer. */
export function NotFoundPageSkeleton(): React.ReactElement {
  return (
    <div className="min-h-dvh xl:min-h-screen flex flex-col">
      <div className="flex-1">
        <div className="w-full mx-auto px-4 md:px-8 max-w-7xl lg:mx-auto print:mx-auto pt-6 print:pt-14">
          <div className="flex justify-center items-center">
            <Skeleton className="h-10 w-32 rounded-xl bg-secondary-light/90" />
          </div>
        </div>
        <div className="max-w-xl flex items-center mx-auto px-4 md:px-8">
          <div className="w-full">
            <div className="flex flex-col justify-center items-center gap-8 w-full min-h-[50vh]">
              <Skeleton className="w-[70%] max-w-md aspect-square rounded-2xl bg-secondary-light/90" />
              <Skeleton className="h-12 w-[80%] max-w-sm rounded-xl bg-secondary-light/90" />
            </div>
          </div>
        </div>
      </div>
      <footer className="w-full mx-auto px-4 md:px-8 max-w-7xl lg:mx-auto print:mx-auto">
        <div className="w-full mb-9 flex justify-center gap-6">
          <Skeleton className="h-4 w-24 rounded-lg bg-secondary-light/80" />
          <Skeleton className="h-4 w-24 rounded-lg bg-secondary-light/80" />
        </div>
      </footer>
    </div>
  );
}
